// @flow
import * as React from "react";
import {
    ProposalBoxLeftColumn,
    ProposalBoxMiddleColumn,
    ProposalBoxRightColumn,
    ProposalPinImage
} from "../AddressesStyle";
import {FreeSelectionRowContainer} from "./AddressRowStyle";

export type PinImage = {|
    src: string,
    alt: string,
|}

type OwnProps = {|
    addressTitleLabel: React.Node,
    addressField: React.Node,
    pinImageMain?: PinImage,
    pinImageSecondary?: PinImage,
|};

const AddressRow = (props: OwnProps) => {
    return (
        <FreeSelectionRowContainer>
            {props.pinImageMain && (
                <ProposalBoxLeftColumn>
                    <ProposalPinImage {...props.pinImageMain}/>
                </ProposalBoxLeftColumn>)
            }

            <ProposalBoxMiddleColumn>
                {props.addressTitleLabel}
                {props.addressField}
            </ProposalBoxMiddleColumn>

            {props.pinImageSecondary && (
                <ProposalBoxRightColumn>
                    <img {...props.pinImageSecondary} alt="secondary"/>
                </ProposalBoxRightColumn>)
            }

        </FreeSelectionRowContainer>
    );
};

export default AddressRow;


// WEBPACK FOOTER //
// ./src/Components/Address/AddressRow/AddressRow.js